const ITEMS = ["ORIGINAL WORKS", "SIGNED LIMITED EDITIONS", "CUSTOM MURALS", "ART WITHOUT PERMISSION"];

export const Marquee = () => (
  <div className="overflow-hidden bg-acid text-ink border-y border-ink" data-testid="editorial-marquee" aria-hidden="true">
    <div className="flex whitespace-nowrap animate-marquee w-max py-2.5">
      {[...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS].map((t, i) => (
        <span key={i} className="font-display text-xl sm:text-2xl tracking-wide px-6 flex items-center gap-6">
          {t}
          <span className="text-pink text-base">✕</span>
        </span>
      ))}
    </div>
  </div>
);
